// src/pages/agency/AgencyLogin.js
import React from 'react';
import LoginPage from '../../components/LoginPage';

const AgencyLogin = () => {
  return (
    <LoginPage userStr="代理店" userType="agency" pageTitle="代理店ログイン" />
  );
};

export default AgencyLogin;